import axios from "axios";
import baseURL from "./base_url";

const templateCollectionApi = axios.create({
  baseURL,
});

export const getTemplateCollections = (limit, offset) => {
  return templateCollectionApi
    .get(`/templateCollection/list?limit=${limit}&offset=${offset}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const createTemplateCollection = (data) => {
  return templateCollectionApi
    .post(`/templateCollection/create`, data, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const deleteCollection = (template_name) => {
  return templateCollectionApi
    .delete(`templateCollection/delete/${template_name}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};

export const getTemplateCollectionByName = (template_collection_name) => {
  return templateCollectionApi
    .get(`templateCollection/findByName/${template_collection_name}`, {
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    })
    .then(({ data }) => data)
    .catch((err) => Promise.reject(err));
};
